module.exports = __webpack_public_path__ + "img/c2.9d7af5c9.jpg";